export default __webpack_public_path__ + "static/media/anvandaforkortningar1.e5cdafc0.png";